import { inject, Pipe, PipeTransform } from '@angular/core';
import { LikutMekabelDisplay, LikutProductDisplayNewRoute } from '@components/likut-task/likut-task.component';
//likut-scan
import { LikutBarcodeScanItem, ScanHistorySummedDictionary } from '@interfaces/likut';
import { LikutScanService } from '@services/likut-scan.service';

const valueDictionary: Record<keyof ScanHistorySummedDictionary[string], 'qty' | 'packQty'> = {
	quantity: 'packQty',
	weight: 'qty',
};

@Pipe({
	name: 'likutScan',
})
export class LikutScanPipe implements PipeTransform {
	private _likutScan = inject(LikutScanService);
	transform(array: LikutBarcodeScanItem[], emitValues: keyof ScanHistorySummedDictionary[string], line?: LikutProductDisplayNewRoute | LikutMekabelDisplay): number {
		if (!array.length || !emitValues || !line?.likut) {
			return 0;
		}

		const key = valueDictionary[emitValues];

		return array.filter(scan => this._likutScan.isScanForTask(scan, line.likut)).reduce((acc, scan) => acc + scan[key], 0);
	}
}
